export const INTEGRATIONS = [
    {
        type: 'gcalendar',
        configurable: true,
        oauth: true,
        button: {
            wording: 'settings.Sign in with Google',
            image: '/assets/img/oauth-google.svg',
            className: 'google-button'
        }
    },
    {
        type: 'outlook',
        configurable: true,
        oauth: true
    },
    {
        type: 'youtube',
        configurable: true,
        oauth: true,
        button: {
            wording: 'settings.Sign in to Youtube',
            image: '/assets/img/logo-youtube.svg',
            className: 'youtube-button'
        }
    },
    {
        type: 'brightcove',
        configurable: true,
        oauth: false
    }
] as const;
